import { useState } from 'react'
import {
	EuiButtonEmpty,
	EuiButtonIcon,
	EuiContextMenuPanel,
	EuiContextMenuItem,
	EuiFlexGroup,
	EuiFlexItem,
	EuiPopover,
} from '@equipmentshare/ds2'

import { CursorPaginationProps } from './types'

export default function CursorPaginationEui( { pageInfo, pageForward, pageBackward, rowSize, setRowSize }: CursorPaginationProps ) {
	const [ isPopoverOpen, setIsPopoverOpen ] = useState( false )

	const onButtonClick = () => setIsPopoverOpen( !isPopoverOpen )
	const closePopover = () => setIsPopoverOpen( false )

	const getIcon = ( size: number ) => {
		return size === rowSize ? 'check' : 'empty'
	}

	const showPagination = !!pageInfo.hasNextPage || !!pageInfo.hasPreviousPage

	const button = (
		<EuiButtonEmpty
			size="xs"
			color="text"
			iconType="arrowDown"
			iconSide="right"
			onClick={onButtonClick}
		>
			Rows per page: {rowSize}
		</EuiButtonEmpty>
	)

	const items = [
		<EuiContextMenuItem
			key="10 rows"
			icon={getIcon( 10 )}
			onClick={() => {
				closePopover()
				setRowSize?.( 10 )
			}}
		>
			10 rows
		</EuiContextMenuItem>,
		<EuiContextMenuItem
			key="20 rows"
			icon={getIcon( 20 )}
			onClick={() => {
				closePopover()
				setRowSize?.( 20 )
			}}
		>
			20 rows
		</EuiContextMenuItem>,
		<EuiContextMenuItem
			key="50 rows"
			icon={getIcon( 50 )}
			onClick={() => {
				closePopover()
				setRowSize?.( 50 )
			}}
		>
			50 rows
		</EuiContextMenuItem>,
	]

	return (
		<EuiFlexGroup
			justifyContent="spaceBetween"
			alignItems="center"
			responsive={false}
		>
			<EuiFlexItem grow={false}>
				{ setRowSize !== undefined && (
					<EuiPopover
						button={button}
						isOpen={isPopoverOpen}
						closePopover={closePopover}
						panelPaddingSize="none"
					>
						<EuiContextMenuPanel items={items} />
					</EuiPopover>
				) }
			</EuiFlexItem>
			<EuiFlexItem grow={false}>
				{ showPagination && (
					<EuiFlexGroup justifyContent="flexEnd" gutterSize="xs">
						<EuiFlexItem grow={false}>
							<EuiButtonIcon
								aria-label="Previous page"
								iconType="arrowLeft"
								id="prevBtn"
								color="text"
								display="empty"
								isDisabled={!pageInfo.hasPreviousPage}
								onClick={pageBackward( pageInfo.startCursor )}
							/>
						</EuiFlexItem>
						<EuiFlexItem grow={false}>
							<EuiButtonIcon
								aria-label="Next page"
								iconType="arrowRight"
								id="nextBtn"
								color="text"
								display="empty"
								isDisabled={!pageInfo.hasNextPage}
								onClick={pageForward( pageInfo.endCursor )}
							/>
						</EuiFlexItem>
					</EuiFlexGroup>
				) }
			</EuiFlexItem>
		</EuiFlexGroup>
	)
}
